function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { useGlobalContext } from 'seagull';
import * as Sentry from '@sentry/react';
import { useStoreActions } from "../../../../../contexts";
import { BankAccountDetailsModal as BankAccountDetailsModalNew } from "../../../../../BankAccountDetailsModal";
import { PlaidMode, usePlaidState } from "../../../../../hooks/usePlaidState";
import { StepLayout, StepSubtitle, StepHelperText, ActionButton } from "../../BusinessOnboardingWidget.utils";
import { ConnectBankAccountIcon } from "../../BusinessOnboardingWidget.icons";
import styles from "./ConnectBankAccount.module.scss";
import ExternalLinkButton from "../../../../../components/ExternalLinkButton";
import { getIntercomHelpArticle } from "../../../../../infra/utils";
import { BusinessChannelEventBinder, PusherEvent } from "../../../../../pusher";
export default function ConnectBankAccount(props) {
  const {
    isComplete,
    userInfo
  } = props;
  const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.worksAt;
  const {
    setWorksAt,
    logBI,
    api
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const [plaidCanceled, setPlaidCanceled] = useState(false);
  const [showingManualBankAccountModal, setShowingManualBankAccountModal] = useState(false);
  const [isConnectingInProgress, setIsConnectingInProgress] = useState(false);
  const BankAccountDetailsModal = BankAccountDetailsModalNew;
  const onDetailsSubmit = async _ref => {
    let {
      routingNumber,
      accountNumber
    } = _ref;
    logBI(11212);
    setShowingManualBankAccountModal(false);
    globalContext.startLoader();
    try {
      await api.vendor.authorizeVendorBankAccount({
        routingNumber,
        accountNumber
      });
    } catch (err) {
      Sentry.captureException(err);
      globalContext.showErrorToast('Error submitting bank account details');
      logBI(11213);
    } finally {
      globalContext.stopLoader();
    }
  };
  const onDetailsCancel = () => {
    setShowingManualBankAccountModal(false);
  };
  const plaidLink = usePlaidState({
    mode: {
      type: PlaidMode.Vendor
    },
    onSuccess(_account) {
      logBI(11210);
    },
    onError(_error) {
      logBI(11211);
      setPlaidCanceled(true);
      setIsConnectingInProgress(false);
    },
    onExit() {
      setPlaidCanceled(true);
      setIsConnectingInProgress(false);
    }
  });
  async function onVendorBankAccountConnectedPushEvent(_event) {
    setIsConnectingInProgress(false);
    if (worksAt) {
      setWorksAt(_objectSpread(_objectSpread({}, worksAt), {}, {
        hasLinkedBankAccount: true
      }));
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BusinessChannelEventBinder, {
    eventName: PusherEvent.VendorBankAccountConnected,
    callback: onVendorBankAccountConnectedPushEvent
  }), /*#__PURE__*/React.createElement(StepLayout, {
    id: "connectBankAccount",
    title: isComplete ? "You've successfully connected your bank account" : 'Connect Anchor to your bank account to get paid on time, every time',
    subtitle: isComplete ? 'Payments will be transferred directly to it.' : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepSubtitle, null, "Provide your bank details to receive client payments automatically."), /*#__PURE__*/React.createElement(StepSubtitle, null, "ACH fees may apply.", ' ', /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      variant: "paragraph2",
      testid: "onboarding-widget-connect-account-read-more",
      href: getIntercomHelpArticle('5661179-payments-via-anchor'),
      size: "small"
    }, "Read more"))),
    actions: !isComplete && /*#__PURE__*/React.createElement("div", null, plaidCanceled && /*#__PURE__*/React.createElement(StepHelperText, null, "Having trouble connecting your account?"), /*#__PURE__*/React.createElement("div", {
      className: styles.actionsWrapper
    }, plaidCanceled && /*#__PURE__*/React.createElement(ActionButton, {
      skin: "primaryOutline",
      "data-testid": "onboarding-widget-routing-number-btn",
      onClick: () => {
        logBI(11205);
        setShowingManualBankAccountModal(true);
      }
    }, "Use routing and bank number"), /*#__PURE__*/React.createElement(ActionButton, {
      "data-testid": "onboarding-widget-connect-account-btn",
      loading: isConnectingInProgress,
      onClick: () => {
        logBI(11204);
        setIsConnectingInProgress(true);
        plaidLink.open();
      }
    }, "Connect bank account")), showingManualBankAccountModal && /*#__PURE__*/React.createElement(BankAccountDetailsModal, {
      open: true,
      onSubmit: onDetailsSubmit,
      onCancel: onDetailsCancel
    })),
    icon: /*#__PURE__*/React.createElement(ConnectBankAccountIcon, null)
  }));
}